import React from 'react';

const YouTube = (props) => (
  <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M34.3537 7.75519C33.9612 6.27706 32.8045 5.11294 31.336 4.71788C28.6741 4 18.0003 4 18.0003 4C18.0003 4 7.32653 4 4.66459 4.71788C3.19603 5.113 2.03941 6.27706 1.64684 7.75519C0.933594 10.4344 0.933594 16.0243 0.933594 16.0243C0.933594 16.0243 0.933594 21.6141 1.64684 24.2933C2.03941 25.7714 3.19603 26.8871 4.66459 27.2821C7.32653 28 18.0003 28 18.0003 28C18.0003 28 28.674 28 31.336 27.2821C32.8045 26.8871 33.9612 25.7714 34.3537 24.2933C35.067 21.6141 35.067 16.0243 35.067 16.0243C35.067 16.0243 35.067 10.4344 34.3537 7.75519ZM14.5093 21.0994V10.9491L23.4305 16.0244L14.5093 21.0994Z" fill="white"/>
  </svg>
);

export default YouTube;
